import { useState, useContext, useEffect } from "react";
import { ReactReduxContext } from 'react-redux';

const useArtistCharts = (id) => {
  const [hasCharts, setBoolCharts] = useState(false); 
  const { store } = useContext(ReactReduxContext);
  const state = store.getState();

  useEffect(() => {
    if (state.api && id) {
      state.api.getFromApi(`/v4/catalog/charts/?enabled=true&is_published=true&per_page=1&dj_id=${id}`, false)
        .then( response => setBoolCharts(response.data.count > 0) )
        .catch( e => {
          console.log(`Error useArtistCharts`, e);
          setBoolCharts(false)
        } );
      }
  }, [state.api, id]);

  return hasCharts;
};

export default useArtistCharts;
